import { saveToCache } from 'src/core/classes/cache/Cache'
import StorageKeys from 'src/core/classes/cache/StorageKeys'
import { proxyIdentity } from 'src/core/classes/helpers/UrlHelper'
import { Rest } from 'src/core/classes/http'
import { authService } from 'src/core/classes/services/AuthService'
import Logger from 'src/core/utils/Logger'

interface IRuntime {
  [key: string]: { data: any }
}

interface IResponse {
  data: object[]
}

export class StorageApi {
  private static runtime: IRuntime = {}
  private static fetchPromise: Promise<any> | void
  /**
   * @param key
   * @param value
   */
  public static async set(key: string, value: object): Promise<any> {
    StorageApi.runtime = await this.restSet(key, value)
    await saveToCache(StorageKeys.settings, StorageApi.runtime)
    return value
  }

  /**
   * @param key
   */
  public static get(key: string): any | undefined {
    try {
      const row = StorageApi.runtime[key] || {}
      if (row) {
        return row.data
      }
    } catch (e) {
      Logger.error(e)
    }
    return undefined
  }

  // used in storage api. remove when remove storageApi class
  public static setDataToStorage = async (data: any) => {
    this.runtime = data
  }

  private static async restSet(key: string, value: object): Promise<any> {
    await authService.checkIdentityToken() // TODO: MOVE TO RTK AND REMOVE THIS CHECK
    const url = proxyIdentity('/mbe/api/v2/user/settings')

    if (!StorageApi.runtime[key]) {
      StorageApi.runtime[key] = { data: {} }
    }

    StorageApi.runtime[key].data = value
    await Rest.put({ url, payload: { ...StorageApi.runtime }, identityToken: true })
    return await this.fetch()
  }

  private static fetch = async (): Promise<IResponse[]> => {
    if (!StorageApi.fetchPromise) {
      StorageApi.fetchPromise = new Promise(async (res) => {
        const url = proxyIdentity('/mbe/api/v2/user/settings')
        const data = await Rest.get({ url, identityToken: true })
        StorageApi.fetchPromise = undefined
        res(data)
      })
    }
    return await StorageApi.fetchPromise
  }
}
